/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';

/**
 * 
 * @export
 * @interface ControlBadRequestError
 */
export interface ControlBadRequestError {
    /**
     * 
     * @type {number}
     * @memberof ControlBadRequestError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof ControlBadRequestError
     */
    title: string;
    /**
     * 
     * @type {Message}
     * @memberof ControlBadRequestError
     */
    message: Message;
}

/**
 * Check if a given object implements the ControlBadRequestError interface.
 */
export function instanceOfControlBadRequestError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function ControlBadRequestErrorFromJSON(json: any): ControlBadRequestError {
    return ControlBadRequestErrorFromJSONTyped(json, false);
}

export function ControlBadRequestErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlBadRequestError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': MessageFromJSON(json['message']),
    };
}

export function ControlBadRequestErrorToJSON(value?: ControlBadRequestError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': MessageToJSON(value.message),
    };
}

